import React, { useEffect, useState } from "react";
import "./settings.css";
import CheckBox3 from "../../ui/atoms/checkbox/CheckBox3";
import Button from "../../ui/atoms/buttons/Button";
import Loading from "../../ui/atoms/loading/Loading";
import { IoSchool } from "react-icons/io5";
import { FaPlusCircle } from "react-icons/fa";
import { FaCircleCheck } from "react-icons/fa6";
import { useSelector, useDispatch } from "react-redux";
import { configurationSlice } from "../../app/store/slices/configurationSlice";
import { setCredentials } from "../../app/store/slices/authSlice";
import {
  capitalize,
  capitalizeAll,
  isEmpty,
  wait,
} from "../../core/utils/helpers";
import { onGetUserSettings, onNewlogin } from "./services/settings";
import moment from "moment";
import Swal from "sweetalert2";
//
import NewSchool from "./components/school/NewSchool";
import Subscription from "./components/subscription/Subscription";
import PasswordManagement from "./components/password-management/PasswordManagement";
//
import useAxiosPrivate from "../../app/providers/context-provider/useAxiosPrivate";

const Settings = () => {
  const [myInscriptions, setMyInscriptions] = useState([]);
  const [mySubscriptions, setMySubscriptions] = useState([]);
  const [isRefresh, setIsRefresh] = useState(false);
  const [isToggleSettingModal, setIsToggleSettingModal] = useState(false);
  const [toggleType, setToggleType] = useState("");

  const [isLoading, setIsLoading] = useState(true);

  const dispatch = useDispatch();
  const axiosPrivate = useAxiosPrivate();

  const initConnectedUser = useSelector(
    (state) => state.setInitConf.initConnectedUser,
  );
  const _sys_role = initConnectedUser?.sys_role;
  const _login_id = initConnectedUser?.login_id;

  const userInformations = useSelector(
    (state) => state.setInitConf.userInformations,
  );
  const _user_id = userInformations?.id;

  const currentConnectedStream = useSelector(
    (state) => state.setInitConf.currentConnectedStream,
  );

  useEffect(() => {
    const fetchData = async () => {
      await wait(1500);

      let isMounted = true;
      const controller = new AbortController();
      const signal = controller.signal;

      const local_data = {
        user_id: _user_id,
        sys_role: _sys_role,
      };

      await onGetUserSettings(axiosPrivate, local_data, signal).then(
        (response) => {
          const _data = response?.data?.result;
          setMyInscriptions(_data?.my_inscriptions);
          setMySubscriptions(_data.my_subscriptions);
        },
      );
      setIsLoading(false);

      return () => {
        isMounted = false;
        isMounted && controller.abort();
      };
    };
    fetchData();
  }, [isRefresh]);

  const onHandleNewLogin = async (_row) => {
    const result = await Swal.fire({
      title: "Logout",
      html: `
        <span style="font-size:1rem; color:grey;">
          You are about to leave your current session:
          <br /><br />
          <strong>
            School of ${capitalizeAll(currentConnectedStream?.school_title)}
          </strong>:
          ${capitalizeAll(currentConnectedStream?.stream_title)}
          <br /><br />
          And connect to:
          <br />
          <strong>
            School of ${capitalizeAll(_row?.school_title)}
          </strong>
          :
          ${capitalizeAll(_row?.stream_title)}
          <br /><br />
          Do you really want to log out?
        </span>`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, I do",
    });

    if (result.isConfirmed) {
      Swal.fire({
        title:
          '<span style="font-size:1rem; color:grey;">Stopping session and logout process ongoing...</span>',
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,

        didOpen: () => {
          Swal.showLoading();
        },
      });

      // attendre 1.5 sec
      await wait(1500);

      const local_data = {
        login_id: _login_id,
        user_infos: JSON.stringify(userInformations),
        next_inscription: JSON.stringify(_row),
        dates: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
      };
      //
      onNewlogin(axiosPrivate, local_data)
        .then((response) => {
          const _data = response?.data;
          if (_data?.isLogged) {
            //
            const _access_token = _data?.accessToken;
            const sys_role = _sys_role;

            dispatch(
              configurationSlice.actions.setCurrentConnectedStream(_row),
            );

            dispatch(
              setCredentials({
                _access_token,
                sys_role,
              }),
            );

            // fermer swal si nécessaire
            Swal.close();

            const to = "/" + sys_role;
            window.open(to, "_self");
          } else {
            Swal.fire({
              title: `Login to School of ${capitalizeAll(_row?.school_title)} : ${capitalizeAll(_row?.stream_title)}`,
              text: _data?.message,
              icon: "info",
              confirmButtonColor: "#2840a8",
            });
          }
        })
        .catch((error) => {
          Swal.close();
          if (!error?.response) {
            Swal.fire({
              title: `Login to School of ${capitalizeAll(_row?.school_title)} : ${capitalizeAll(_row?.stream_title)}`,
              text: "No server response",
              icon: "warning",
              confirmButtonColor: "#2840a8",
            });
          } else {
            Swal.fire({
              title: `Login to School of ${capitalizeAll(_row?.school_title)} : ${capitalizeAll(_row?.stream_title)}`,
              text: error?.response?.data?.detail?.message,
              icon: "error",
              confirmButtonColor: "#2840a8",
            });
          }
        });
    }
  };

  return (
    <React.Fragment>
      <div className="settings">
        {isLoading ? (
          <div className="w-full h-full d-flex align-center justify-center">
            <Loading type={"type-2"} />
          </div>
        ) : (
          <div className="settings-wrapper">
            <h1>Settings</h1>
            <p>
              View your profile, default configuration and Setting options
              according to your needs
            </p>
            <hr />
            {_sys_role !== "admin" && (
              <React.Fragment>
                <div className="s-w-section">
                  <h2>My Schools</h2>
                  <div className="s-w-section-content my-schools">
                    <button
                      className="btn-new-school"
                      onClick={() => {
                        setToggleType("school");
                        setIsToggleSettingModal(!isToggleSettingModal);
                      }}
                    >
                      <FaPlusCircle className="icon" />
                      <span>Get new school's inscription</span>
                    </button>
                    {myInscriptions?.map((row) => {
                      return (
                        <div
                          className={
                            row?.inscription_id ===
                            currentConnectedStream?.inscription_id
                              ? "school-item is-active"
                              : "school-item"
                          }
                          key={row?.inscription_id}
                          onClick={async () => onHandleNewLogin(row)}
                        >
                          <span className="span-icon">
                            <IoSchool className="icon" />
                          </span>
                          <div className="school-item-description">
                            <h3>
                              School of {capitalizeAll(row?.school_title)}
                            </h3>
                            <p>#Stream : {capitalizeAll(row?.stream_title)}</p>
                          </div>
                          {row?.inscription_id ===
                            currentConnectedStream?.inscription_id && (
                            <span className="span-mark">
                              <FaCircleCheck className="icon" />
                            </span>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </div>
                <div className="s-w-section">
                  <h2>Subscription History</h2>
                  <div className="s-w-section-content my-subscriptions">
                    <div className="w-fit-content mb-xs">
                      <Button
                        type={"button"}
                        preferedStyle={"normal"}
                        title={"Get Subscription"}
                        action={() => {
                          setToggleType("subscription");
                          setIsToggleSettingModal(!isToggleSettingModal);
                        }}
                      />
                    </div>
                    <div className="table">
                      <table>
                        <thead>
                          <tr>
                            <th className="col-20 text-align-left">
                              Date of Payment
                            </th>
                            <th className="col-20 text-align-left">
                              Date of End
                            </th>
                            <th className="col-25 text-align-left">Details</th>
                            <th className="col-05 text-align-center">Amount</th>
                            <th className="col-05 text-align-center">Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          {mySubscriptions?.map((subscription, idx) => {
                            return (
                              idx <= 4 &&
                              subscription?.payment_inscription_id ===
                                currentConnectedStream?.inscription_id && (
                                <tr key={idx}>
                                  <td className="col-15 text-align-left">
                                    {moment(
                                      subscription?.subscription_start_date,
                                    ).format("LLLL")}
                                  </td>
                                  <td className="col-15 text-align-left">
                                    {moment(
                                      subscription?.subscription_end_date,
                                    ).format("LLLL")}
                                  </td>
                                  <td className="col-30 text-align-left">
                                    <h3>
                                      {capitalizeAll(
                                        subscription?.payment_reference,
                                      )}
                                    </h3>
                                  </td>
                                  <td className="col-05 text-align-center">
                                    {subscription?.payment_amount > 0
                                      ? `${subscription?.payment_currency} ${subscription?.payment_amount.toFixed(2)}`
                                      : subscription?.payment_amount.toFixed(2)}
                                  </td>
                                  <td className="col-05 text-align-center">
                                    {moment(new Date()).isSameOrBefore(
                                      subscription?.subscription_end_date,
                                    )
                                      ? "On going"
                                      : "Expired"}
                                  </td>
                                </tr>
                              )
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </React.Fragment>
            )}
            <div className="s-w-section">
              <h2>Personal Information</h2>
              <div className="s-w-section-content user-profile">
                <div className="profile-picture">
                  <img
                    src={
                      !isEmpty(userInformations?.thumbnail)
                        ? `${process.env.REACT_APP_API_SERVER_URL}:${process.env.REACT_APP_API_SERVER_PORT}/storage/images/profiles/${userInformations?.thumbnail}`
                        : process.env.PUBLIC_URL + "/user.png"
                    }
                    alt="user illustration"
                  />
                  <button>Change picture</button>
                </div>
                <div className="profile-informations">
                  <div className="p-i-item">
                    <span>Noms</span>
                    <h3>{`${capitalizeAll(userInformations?.firstname)} ${capitalizeAll(userInformations?.lastname)}`}</h3>
                  </div>
                  <div className="p-i-item">
                    <span>Gender</span>
                    <h3>{capitalize(userInformations?.gender)}</h3>
                  </div>
                  <div className="p-i-item">
                    <span>Date of Birth</span>
                    <h3>
                      {moment(userInformations?.date_of_birth).format("LLLL")}
                    </h3>
                  </div>
                  <div className="p-i-item">
                    <span>Location of Birth</span>
                    <h3>{userInformations?.location_of_birth}</h3>
                  </div>
                  <div className="p-i-item">
                    <span>Country of Origin</span>
                    <h3>{userInformations?.origin_country}</h3>
                  </div>
                  <div className="p-i-item">
                    <span>E-mail</span>
                    <h3>{userInformations?.mail}</h3>
                  </div>
                  <div className="p-i-item">
                    <span>Phone Number</span>
                    <h3>{userInformations?.phone_number || "---"}</h3>
                  </div>
                  <div className="p-i-item">
                    <span>Profession</span>
                    <h3>{capitalize(userInformations?.profession)}</h3>
                  </div>
                  <div className="p-i-item">
                    <span>Account Status</span>
                    <h3>
                      {userInformations?.is_activated
                        ? "Activated"
                        : "DesActivated"}
                    </h3>
                  </div>
                  <div className="p-i-item">
                    <span>Password</span>
                    <Button
                      type={"button"}
                      preferedStyle={"default"}
                      title={"Click to change Password"}
                      action={() => {
                        setToggleType("password");
                        setIsToggleSettingModal(!isToggleSettingModal);
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="s-w-section">
              <h2>Privacy Settings</h2>
              <div className="s-w-section-content privacy-setting">
                <div className="s-w-s-c-item">
                  <div className="s-w-s-c-item-description">
                    <h3>Public Profile</h3>
                    <span>
                      Make your profile visible to everyone(Classmates)
                    </span>
                  </div>
                  <CheckBox3 />
                </div>
                <div className="s-w-s-c-item">
                  <div className="s-w-s-c-item-description">
                    <h3>Notification</h3>
                    <span>Receive push notification while connected</span>
                  </div>
                  <CheckBox3 />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      {/* New Actions */}
      <div
        className={
          isToggleSettingModal
            ? "settings-modal slide-in"
            : "settings-modal slide-out"
        }
      >
        <div className="settings-modal-wrapper">
          <div className="stage-head w-full">
            <div className="w-fit-content">
              <h1>
                ♻️ {toggleType === "school" && "Get Inscription"}
                {toggleType === "subscription" && "Get SUBSCRIPTION"}
                {toggleType === "password" && "Changing My Passord"}
              </h1>
              <p>
                {toggleType === "school" &&
                  "Getting a new Inscription from a SCHOOL require to follow the process by passing the adminission test."}
                {toggleType === "subscription" &&
                  "Getting a new Subscription is strongly linked to the actual active School."}
                {toggleType === "password" &&
                  "You can Change your password any time needed."}
              </p>
            </div>
            <Button
              type={"button"}
              preferedStyle={"default"}
              title={"❌ Close"}
              action={() => {
                setToggleType("");
                setIsToggleSettingModal(!isToggleSettingModal);
              }}
            />
          </div>
          <div className="stage-container">
            {isToggleSettingModal && toggleType === "school" && (
              <NewSchool
                user_id={_user_id}
                myInscriptions={myInscriptions}
                setIsRefresh={setIsRefresh}
              />
            )}
            {isToggleSettingModal && toggleType === "subscription" && (
              <Subscription
                inscription_id={currentConnectedStream?.inscription_id}
                setIsRefresh={setIsRefresh}
              />
            )}
            {isToggleSettingModal && toggleType === "password" && (
              <PasswordManagement user_id={_user_id} />
            )}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Settings;
